var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "854px",
    height: "212px",
    viewBox: "0 0 854 212",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fill: "#e1ff03"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.2,0.9 L42,0.9 L0,42.9 L0,100.7 C1.9,102.6 2.9,103.6 4.8,105.5 L94.5,105.5 L94.5,84.9 L184.2,84.9 C186.1,83 187.1,82 189,80.1 L189,5.7 C187.2,3.8 186.1,2.8 184.2,0.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,126.1 C3,128 2,129 0.1,130.9 L0.1,206.2 C2,208.1 3,209.1 4.9,211 L147.1,211 L189.1,169 L189.1,110.2 C187.2,108.3 186.2,107.3 184.3,105.4 L94.6,105.4 L94.6,126 L4.9,126 L4.9,126.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4,5.7 C414.5,3.8 413.5,2.8 411.6,0.9 L328.6,0.9 L328.6,0.9 C326.7,2.8 325.7,3.8 323.8,5.7 L323.8,105.5 L302.7,105.5 L302.7,5.7 C300.8,3.8 299.8,2.8 297.9,0.9 L214.9,0.9 C213,2.8 212,3.8 210.1,5.7 L210.1,105.5 L266.9,162.4 L266.9,206.3 C268.8,208.2 269.8,209.2 271.7,211.1 L354.7,211.1 C356.6,209.2 357.6,208.2 359.5,206.3 L359.5,162.4 L416.3,105.5 L416.3,5.7 L416.4,5.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.9,5.7 C852,3.8 851,2.8 849.1,0.9 L766.1,0.9 L766.1,0.9 C764.2,2.8 763.2,3.8 761.3,5.7 L761.3,105.5 L740.2,105.5 L740.2,5.7 C738.3,3.8 737.3,2.8 735.4,0.9 L652.4,0.9 C650.5,2.8 649.5,3.8 647.6,5.7 L647.6,105.5 L704.4,162.4 L704.4,206.3 C706.3,208.2 707.3,209.2 709.2,211.1 L792.2,211.1 C794.1,209.2 795.1,208.2 797,206.3 L797,162.4 L853.8,105.5 L853.8,5.7 L853.9,5.7 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M621.7,0.9 L479.5,0.9 L437.5,42.9 L437.5,206.3 C439.4,208.2 440.4,209.2 442.3,211.1 L525.3,211.1 C527.2,209.2 528.2,208.2 530.1,206.3 L530.1,180.2 L621.7,180.2 C623.6,178.3 624.6,177.3 626.5,175.4 L626.5,110.4 C624.6,108.5 623.6,107.5 621.7,105.6 L530.1,105.6 L530.1,84.9 L621.7,84.9 C623.6,83 624.6,82 626.5,80.1 L626.5,5.7 C624.7,3.8 623.6,2.8 621.7,0.9 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.c363c647f3c3a320ab5965323fa0b633.svg";